"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var propTypes = {
    buttonText: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
    popUpText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    popupStyle: PropTypes.object,
    onAccept: PropTypes.func.isRequired,
    onCancel: PropTypes.func,
    testId: PropTypes.string,
};
var Popup = function (_a) {
    var buttonText = _a.buttonText, popUpText = _a.popUpText, popupStyle = _a.popupStyle, onAccept = _a.onAccept, onCancel = _a.onCancel, testId = _a.testId;
    var popupRef = React.useRef(null);
    var triggerRef = React.useRef(null);
    var _b = React.useState(false), isPopupOpen = _b[0], setIsPopupOpen = _b[1];
    var _c = React.useState({ centerX: 0, centerY: 0 }), center = _c[0], setCenter = _c[1];
    var centerContent = React.useCallback(function () {
        if (triggerRef && triggerRef.current) {
            var _a = triggerRef.current.getBoundingClientRect(), left = _a.left, top_1 = _a.top, width = _a.width, height = _a.height;
            var centerX = left + width / 2;
            var centerY = top_1 + height / 2;
            setCenter({
                centerX: centerX,
                centerY: centerY,
            });
        }
    }, []);
    var handleBodyClick = React.useCallback(function () {
        setIsPopupOpen(false);
    }, []);
    React.useEffect(function () {
        centerContent();
        if (!isPopupOpen) {
            window.removeEventListener('scroll', centerContent, true);
            document.body.removeEventListener('click', handleBodyClick, true);
        }
        else {
            window.addEventListener('scroll', centerContent, true);
            document.body.addEventListener('click', handleBodyClick, true);
        }
    }, [isPopupOpen]);
    var togglePopup = function () { return setIsPopupOpen(!isPopupOpen); };
    return (React.createElement("div", { className: "Popup", "data-testid": testId, ref: popupRef },
        React.createElement("button", { ref: triggerRef, type: "button", className: "Button Button--small", onClick: togglePopup }, buttonText),
        React.createElement("div", { className: "Popup-container Popup-container--overlay " + (isPopupOpen ? 'is-open' : ''), style: __assign(__assign({}, popupStyle), { top: center.centerY, left: center.centerX }) },
            React.createElement("div", { className: "Popup-content u-padMd" },
                React.createElement("div", { className: "u-textLeft" }, popUpText),
                React.createElement("div", { className: "u-textCenter u-spaceTopMd" },
                    React.createElement("button", { type: "button", onClick: onCancel, className: "u-spaceRightSm Button Button--negative" }, "Cancel"),
                    React.createElement("button", { type: "button", onClick: onAccept, className: "Button Button--primary" }, "Confirm"))))));
};
exports.default = Popup;
